<template lang="pug">
div.progress-circle
  svg(:width="126" :height="126" :viewBox="`0 0 ${size} ${size}`")
    defs
    linearGradient#grad(
      x1="0%"
      y1="0%"
      x2="100%"
      y2="100%"
      gradientTransform="rotate(315.74)"
    )
      stop(offset="-26.99%", stop-color="#FF9900")
      stop(offset="69.92%", stop-color="#F6514C")
    circle.bg(:cx="half" :cy="half" :r="radius" :stroke-width="stroke")
    circle.fg(
      :cx="half"
      :cy="half"
      :r="radius"
      :stroke-width="stroke"
      :stroke-dasharray="circumference"
      :stroke-dashoffset="offset"
      stroke-linecap="round"
    )
  div.text.text-24 {{ returnRoundedProcent }}%
  div.star 
    img(src="@/assets/star.svg")
</template>

<script>
export default {
  name: 'ProgressCircle',
  props: {
    progress: { type: Number, default: 0 },
    size: { type: Number, default: 100 },
    stroke: { type: Number, default: 6 },
  },

  computed: {

    returnRoundedProcent() {
      return Math.round(this.progress)
    },

    radius() {
      return (this.size - this.stroke) / 2;
    },

    half() {
      return this.size / 2;
    },

    circumference() {
      return 2 * Math.PI * this.radius;
    },

    offset() {
      return this.circumference * (1 - this.progress / 100);
    },

  },
};
</script>

<style scoped>
.progress-circle {
  position: relative;
  display: inline-block;
}

svg {
  transform: rotate(-90deg);
}

.bg {
  fill: none;
  stroke: #e5e7eb;
}

.fg {
  fill: none;
  stroke: url(#grad);
  stroke: url(#grad);
  transition: stroke-dashoffset 0.6s ease;
}
.text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #111827;
}
.star {
  position: absolute;
  top: -15px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(90deg, #FACC15 0%, #FDE047 100%);
  color: white;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 4px solid #FFFFFF;
  box-shadow: 0px 20px 25px 0px #0000001A;
  box-shadow: 0px 8px 10px 0px #0000001A;
}
</style>
